import { useState } from "react";
import { Globe, Check, AlertTriangle } from "lucide-react";
import { SecondaryButton } from "./kit";
import api from "../lib/api";

export const SiteReadField = ({ value, onChange }) => {
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState(null);

  const importSite = async () => {
    setBusy(true); setStatus(null);
    try {
      const { data } = await api.post("/site-read", { url: value.trim() });
      if (data.status === "ok") setStatus({ ok: true, chars: data.chars });
      else setStatus({ ok: false, message: data.message });
    } catch {
      setStatus({ ok: false, message: "I couldn't read your site — describe your business instead." });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="site-read-field">
      <label className="font-mono-j text-[9.5px] tracking-[0.12em] text-[#54505B] uppercase block mb-1.5">Your website (optional)</label>
      <div className="flex items-center gap-2.5">
        <input className="field-input !py-2.5 flex-1" placeholder="https://yourbusiness.com" value={value}
          onChange={(e) => { onChange(e.target.value); setStatus(null); }}
          onKeyDown={(e) => { if (e.key === "Enter" && value.trim().length >= 4 && !busy) { e.preventDefault(); importSite(); } }}
          data-testid="site-read-input" />
        <SecondaryButton className="!py-2.5 !px-4 text-[13px]" onClick={importSite} disabled={busy || value.trim().length < 4} data-testid="site-read-btn">
          <Globe size={13} /> {busy ? "Reading…" : "Import"}
        </SecondaryButton>
      </div>
      {status?.ok && (
        <p className="flex items-center gap-1.5 text-[12px] text-[#4B7B4F] mt-1.5" data-testid="site-read-ok">
          <Check size={12} /> Site read — I'll use it to pre-fill your business snapshot.
        </p>
      )}
      {status && !status.ok && (
        <p className="flex items-center gap-1.5 text-[12px] text-[#96691E] mt-1.5" data-testid="site-read-error">
          <AlertTriangle size={12} className="shrink-0" /> {status.message}
        </p>
      )}
    </div>
  );
};
